import React from 'react';

import styles from './mastHeadLanding.module.scss';
import useMediaQuery from 'src/hooks/useMediaQuery';
import { sizes } from 'src/constants/screenSizes';
import LandingHeaderContent from '../LandingHeaderContent';
import LandingStatList from '../LandingStatList';
import { LandingStatItemProps } from 'src/components/molecules/LandingStatItem';
import LandingChallengeCard, { LandingChallengeCardProps } from 'src/components/organisms/LandingChallengeCard';
import ErrorBoundary from 'src/components/utility/ErrorBoundary';
const { main, glowDecor, cardWrapper, statListContainer } = styles;

export type MastHeadLandingProps = {
  statListData: [LandingStatItemProps];
  // Null whenever no challenge carries the matching feature_challenge_N flag —
  // the columns default to false, so an empty or sparse database nulls all three.
  landingChallengeCard1: LandingChallengeCardProps | null;
  landingChallengeCard2: LandingChallengeCardProps | null;
  landingChallengeCard3: LandingChallengeCardProps | null;
  loading: boolean;
};

const MastHeadLanding = ({
  statListData,
  landingChallengeCard1,
  landingChallengeCard2,
  landingChallengeCard3,
  loading,
}: MastHeadLandingProps) => {
  const isS = useMediaQuery(sizes.small);
  const isXS = useMediaQuery(sizes.xSmall);
  const isL = useMediaQuery(sizes.large);

  const description = `enables data science experts and enthusiasts 
  to collaboratively solve real-world problems, through challenges.`;

  // Slot order is card2, card1, card3 — the visual arrangement the masthead has
  // always had, and mastHeadLanding.module.scss positions by [data-card], so the
  // pairing is load-bearing. Unfeatured slots drop out entirely rather than
  // leaving an empty positioned wrapper in the grid.
  const featuredCards = [
    { slot: 'card1', challenge: landingChallengeCard2 },
    { slot: 'card2', challenge: landingChallengeCard1 },
    { slot: 'card3', challenge: landingChallengeCard3 },
  ].filter(({ challenge }) => challenge);

  return (
    <>
      <div className={main}>
        <div style={{ position: 'relative' }}>
          <LandingHeaderContent
            hero
            description={description}
            buttonText="Host a Challenge"
            url="/landing_page/host"
            descriptionWidth={isXS ? '288px' : isS ? '368px' : isL ? '581px' : '624px'}
          />
          <div className={statListContainer}>
            <LandingStatList statListData={statListData} />
          </div>
        </div>
        <div className={cardWrapper}>
          <div className={glowDecor}></div>
          <>
            {featuredCards.map(({ slot, challenge }) => (
              <div data-card={slot} key={slot}>
                <ErrorBoundary name={`LandingChallengeCard (${slot})`}>
                  <LandingChallengeCard loading={loading} {...challenge} priority />
                </ErrorBoundary>
              </div>
            ))}
          </>
        </div>
      </div>
    </>
  );
};

export default MastHeadLanding;
